import React from 'react';

// Page-level context for category pages (Kategori). The page resolves WHICH
// Koleksi are in scope; blocks inside the scaffold (BlockCollectionProducts)
// read this to render them. Kept in its own file so both the page
// (PageProductList) and the block library can import it without a cycle.
export interface CategoryPageContextValue {
  categoryId: string;
  collectionHandles: string[];
}

export const CategoryPageContext =
  React.createContext<CategoryPageContextValue | null>(null);
